<template>
  <div>
    <v-alert :value="true" v-if="errorMessage != null" type="error">{{
      errorMessage
    }}</v-alert>
    <PageIntro
      v-if="loggedOut === true"
      :heading="
        '<span>' +
        configStrings.clubName +
        ' ' +
        configStrings.productName +
        '</span>'
      "
      :body="
        '<p>You are now signed out of your ' +
        configStrings.clubName +
        ' ' +
        configStrings.productName +
        '.</p>'
      "
    />
  </div>
</template>

<script>
import PageIntro from "@/components/PageIntro";
import axios from "axios";
import qs from "qs";

export default {
  components: {
    PageIntro,
  },
  data() {
    return {
      errorMessage: null,
      successMessage: null,
      loggedOut: false,
      refreshToken: null,
    };
  },
  mounted() {
    console.log("Hit Token Redirect script");

    // check for query string params to populate
    var search = location.search.substring(1);
    if (search) {
      var parameters = JSON.parse(
        '{"' +
          decodeURI(search)
            .replace(/"/g, '\\"')
            .replace(/&/g, '","')
            .replace(/=/g, '":"') +
          '"}'
      );
      //alert(parameters)
      console.log("PARAMS", parameters);
      if (parameters.token) {
        this.refreshToken = decodeURIComponent(parameters.token).replace(
          " ",
          "+"
        );
      }
    }

    console.log("Refresh Token", this.refreshToken);
    var bodyParams = {
      grant_type: "refresh_token",
      client_id: process.env.VUE_APP_AWS_CLIENT_ID,
      refresh_token: this.refreshToken,
    };

    var vm = this;
    console.log(bodyParams);

    axios({
      method: "post",
      url:
        "https://" +
        process.env.VUE_APP_AWS_COGNITO_AUTH_SERVER +
        "/oauth2/token",
      data: qs.stringify(bodyParams),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    })
      .then(function (response) {
        console.log("response", response);
        var accessToken = response.data.access_token;
        var idToken = response.data.id_token;
        var refreshToken = response.data.refresh_token;
        var userSub = vm.$getUserSubFromIdToken(idToken);
        var secureString = "";
        var expDate = new Date();
        var time = expDate.getTime();
        var expireTime = time + 3600 * 1000 * 24 * 365; //1 year
        expDate.setTime(expireTime);

        if (process.env.VUE_APP_COOKIE_SECURE === "true") {
          secureString = "; secure";
        }

        console.log(
          "cookie set value for VUE_APP_DOMAIN:",
          process.env.VUE_APP_DOMAIN
        );
        document.cookie =
          `CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.${userSub}.refreshToken=` +
          refreshToken +
          `; domain=${
            process.env.VUE_APP_DOMAIN
          }; path=/${secureString}; expires=${expDate.toGMTString()}`;
        document.cookie =
          `CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.${userSub}.accessToken=` +
          accessToken +
          `; domain=${
            process.env.VUE_APP_DOMAIN
          }; path=/${secureString}; expires=${expDate.toGMTString()}`;
        document.cookie =
          `CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.${userSub}.idToken=` +
          idToken +
          `; domain=${
            process.env.VUE_APP_DOMAIN
          }; path=/${secureString}; expires=${expDate.toGMTString()}`;
        document.cookie =
          `CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.LastAuthUser=` +
          userSub +
          `; domain=${
            process.env.VUE_APP_DOMAIN
          }; path=/${secureString}; expires=${expDate.toGMTString()}`;
        document.cookie = `CognitoIdentityServiceProvider.${
          process.env.VUE_APP_AWS_CLIENT_ID
        }.clockDrift=0; domain=${
          process.env.VUE_APP_DOMAIN
        }; path=/${secureString}; expires=${expDate.toGMTString()}`;

        if (localStorage.returnUrl) {
          console.log("redirecting to " + localStorage.returnUrl);
          var redirectTo = localStorage.returnUrl;
          localStorage.removeItem("returnUrl");
          localStorage.removeItem("suppressToken");
          localStorage.removeItem("responseType");
          window.location = redirectTo;
        }
      })
      .catch(function (error) {
        if (error.response) {
          // The request was made and the server responded with a status code(out of the range of 2xx)
          console.error("Error response status:", error.response.status);
          console.error("Error response data:", error.response.data);
        } else if (error.request) {
          // The request was made but no response was received
          console.error("Error request:", error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          console.error("Error message:", error.message);
        }
        console.error("Error config:", error.config);
        vm.$router.push("/login");
      });
  },
};
</script>